import { useState, useEffect } from "react";
import { T } from "../../theme";
import { REL } from "../../theme";
import { usePeople } from "../../context/PeopleContext";
import {
  GS_HOUR_HEIGHT, GS_GRID_START, GS_VISIBLE_HOURS, GS_DAYS, GS_DAY_FULL,
  GS_DATES, GS_TODAY, _CAL_MONTHS, WEEK_DATES, toLocalYMD,
  gsGroupOverlaps, gsHeatmap, gsFmtH, gsFmtRange, gsTotalH, gsHexRgb, fmtWeekDate,
  layoutScheduleEvents,
} from "../../utils/calendarUtils";

function GSChip({partner, selected, onToggle}) {
  const c = partner.color;
  return (<div onClick={()=>onToggle(partner.id)} style={{display:"flex",alignItems:"center",gap:7,padding:"7px 12px",borderRadius:40,background:selected?c+"1A":T.mist,border:`1.5px solid ${selected?c:T.edge}`,cursor:"pointer",transition:"all .15s",boxShadow:selected?`0 0 0 3px ${c}20`:"none",userSelect:"none"}}>
    <div style={{width:28,height:28,borderRadius:"50%",background:selected?c+"30":T.edge,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,fontWeight:700,color:selected?c:T.muted,fontFamily:"'Crimson Pro',serif",flexShrink:0,position:"relative",overflow:"hidden"}}>
      {partner.photo?<img src={partner.photo} style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"50%"}} alt=""/>:partner.initials}
    </div>
    <span style={{fontSize:12,fontWeight:600,color:selected?c:T.muted}}>{partner.name}</span>
    {selected&&<span style={{width:16,height:16,borderRadius:"50%",background:c,display:"flex",alignItems:"center",justifyContent:"center",fontSize:11,color:"white",flexShrink:0}}>✓</span>}
  </div>);
}

function GSHeatmapCol({dayIdx, selectedIds, overlaps, selectedSlot, onSlotClick, onCellClick, myAvail, weekDateNums, todayIdx, people, peerAvailMap, myEvents=[]}) {
  const {counts,total} = gsHeatmap(selectedIds,dayIdx,myAvail,people,peerAvailMap||{});
  const activeDates = weekDateNums || GS_DATES;
  const activeTodayIdx = todayIdx !== undefined ? todayIdx : GS_TODAY;
  const isToday = dayIdx === activeTodayIdx;
  const dayOverlaps = overlaps[dayIdx] || [];
  return (<div style={{flex:1,borderRight:dayIdx<6?`1px solid ${T.edge}`:"none",position:"relative",minWidth:0}}>
    <div style={{height:44,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",borderBottom:`1px solid ${T.edge}`,background:isToday?"#FDF0E6":T.panel,position:"sticky",top:0,zIndex:8}}>
      <span style={{fontSize:11,fontWeight:700,letterSpacing:"0.07em",color:isToday?T.partner:T.muted,textTransform:"uppercase"}}>{GS_DAYS[dayIdx]}</span>
      <span style={{fontSize:15,fontFamily:"'Crimson Pro',serif",fontWeight:isToday?700:400,color:isToday?T.partner:T.bark}}>{activeDates[dayIdx]}</span>
    </div>
    {counts.map((count,i)=>{
      const h = GS_GRID_START+i*0.5;
      const handleCellClick = onCellClick ? ()=>onCellClick({key:`${dayIdx}-${h}-${GS_GRID_START+GS_VISIBLE_HOURS}`,dayIdx,startH:h,endH:GS_GRID_START+GS_VISIBLE_HOURS}) : undefined;
      if(count===0) return (<div key={i} onClick={handleCellClick} style={{height:GS_HOUR_HEIGHT/2,background:i%2===0?T.panel:"#F2EBE3",cursor:onCellClick?"pointer":"default"}}/>);
      const intensity = count/total;
      const isAll = count===total;
      const bg = isAll?`rgba(98,126,101,${0.15+intensity*0.35})`:`rgba(${Math.round(196-intensity*80)},${Math.round(160+intensity*20)},${Math.round(80+intensity*40)},${0.12+intensity*0.22})`;
      return (<div key={i} onClick={handleCellClick} style={{height:GS_HOUR_HEIGHT/2,background:bg,borderTop:i%2===0&&i>0?"1px solid rgba(0,0,0,0.04)":"none",position:"relative",cursor:onCellClick?"pointer":"default"}}>
        {isAll&&count>1&&<div style={{position:"absolute",left:3,top:"50%",transform:"translateY(-50%)",width:4,height:"70%",borderRadius:2,background:T.sage}}/>}
      </div>);
    })}
    {dayOverlaps.map(([s,e],i)=>{
      const top = (s-GS_GRID_START)*GS_HOUR_HEIGHT+44;
      const height = (e-s)*GS_HOUR_HEIGHT;
      const key = `${dayIdx}-${s}-${e}`;
      const isSel = selectedSlot?.key===key;
      return (<div key={i} onClick={()=>onSlotClick({key,dayIdx,startH:s,endH:e})} style={{position:"absolute",top,height:height-2,left:2,right:2,background:isSel?T.sage+"30":"transparent",border:`1.5px solid ${isSel?T.sage:"transparent"}`,borderRadius:8,cursor:"pointer",zIndex:5,transition:"all .13s"}}>
        {isSel&&height>24&&<div style={{position:"absolute",top:"50%",left:"50%",transform:"translate(-50%,-50%)",background:T.sage,color:"white",borderRadius:20,padding:"2px 8px",fontSize:11,fontWeight:700,whiteSpace:"nowrap"}}>✓ All free</div>}
      </div>);
    })}
    {(()=>{
      const laid=layoutScheduleEvents(myEvents.filter(ev=>!ev.allDay&&ev.day===dayIdx&&ev.status!=='free'));
      const gap=2;
      return laid.map((ev,i)=>{
        const top=(ev.startH-GS_GRID_START)*GS_HOUR_HEIGHT+44;
        const height=Math.max((ev.endH-ev.startH)*GS_HOUR_HEIGHT,6);
        const colW=ev._totalCols>1?`calc(${100/ev._totalCols}% - ${gap*1.5}px)`:`calc(100% - ${gap*2}px)`;
        const colL=`calc(${(ev._col/ev._totalCols)*100}% + ${gap}px)`;
        return(<div key={`laid-${i}`} style={{position:"absolute",top,height:height-1,left:colL,width:colW,background:T.clay+"25",borderLeft:`2.5px solid ${T.clay}`,borderRadius:"0 3px 3px 0",zIndex:7,pointerEvents:"none",overflow:"hidden",paddingLeft:4,paddingTop:2}}>
          {height>=14&&<span style={{fontSize:11,color:T.clay,fontWeight:700,lineHeight:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis",display:"block"}}>{ev.label}</span>}
        </div>);
      });
    })()}
    {Array.from({length:GS_VISIBLE_HOURS},(_,i)=>(
      <div key={i} style={{position:"absolute",top:44+i*GS_HOUR_HEIGHT,left:0,right:0,height:1,background:T.edge,zIndex:2,pointerEvents:"none"}}/>
    ))}
  </div>);
}

export const RECURRENCE_OPTIONS=[
  {id:"none",label:"Does not repeat"},
  {id:"daily",label:"Daily"},
  {id:"weekly",label:"Weekly"},
  {id:"biweekly",label:"Every 2 weeks"},
  {id:"monthly",label:"Monthly"},
];

export function EventFormFields({startH,setStartH,endH,setEndH,allDay,setAllDay,multiDay,setMultiDay,endDate,setEndDate,startDate,setStartDate,recurrence,setRecurrence,slotDayIdx,slotEndH,isoDate}){
  const fmtH=(h)=>{const hr=Math.floor(h);const min=Math.round((h-hr)*60);const ampm=hr>=12?"PM":"AM";const h12=hr===0?12:hr>12?hr-12:hr;return`${h12}:${String(min).padStart(2,"0")} ${ampm}`;};
  const timeOpts=Array.from({length:48},(_,i)=>{const h=i*0.5;return{value:h,label:fmtH(h)};});
  const effectiveStart=startDate||isoDate||"";

  return(<>
    {/* Start date */}
    <div style={{marginBottom:8}}>
      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Start date</label>
      <input type="date" value={effectiveStart} onChange={e=>{const v=e.target.value;if(setStartDate)setStartDate(v);if(endDate&&v>endDate)setEndDate(v);}} style={{width:"100%",padding:"7px 10px",borderRadius:8,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,color:T.ink,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>
    </div>

    {/* All-day toggle */}
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 0",marginBottom:8}}>
      <span style={{fontSize:12,fontWeight:500,color:T.ink}}>All day</span>
      <button onClick={()=>setAllDay(!allDay)} style={{width:40,height:22,borderRadius:11,background:allDay?T.sage:T.edge,border:"none",cursor:"pointer",position:"relative",transition:"background .15s"}}>
        <div style={{width:16,height:16,borderRadius:"50%",background:"white",position:"absolute",top:3,left:allDay?21:3,transition:"left .15s",boxShadow:"0 1px 3px rgba(0,0,0,.2)"}}/>
      </button>
    </div>

    {!allDay&&<div style={{display:"flex",gap:8,marginBottom:8}}>
      <div style={{flex:1}}>
        <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Start time</label>
        <select value={startH} onChange={e=>{const v=+e.target.value;setStartH(v);if(endH<=v)setEndH(Math.min(v+1,23.5));}} style={{width:"100%",padding:"7px 10px",borderRadius:8,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
          {timeOpts.map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
      <div style={{flex:1}}>
        <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>End time</label>
        <select value={endH} onChange={e=>setEndH(+e.target.value)} style={{width:"100%",padding:"7px 10px",borderRadius:8,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif"}}>
          {timeOpts.filter(o=>o.value>startH).map(o=><option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
    </div>}

    {/* Multi-day toggle */}
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 0",marginBottom:8}}>
      <span style={{fontSize:12,fontWeight:500,color:T.ink}}>Multi-day event</span>
      <button onClick={()=>setMultiDay(!multiDay)} style={{width:40,height:22,borderRadius:11,background:multiDay?T.sage:T.edge,border:"none",cursor:"pointer",position:"relative",transition:"background .15s"}}>
        <div style={{width:16,height:16,borderRadius:"50%",background:"white",position:"absolute",top:3,left:multiDay?21:3,transition:"left .15s",boxShadow:"0 1px 3px rgba(0,0,0,.2)"}}/>
      </button>
    </div>

    {multiDay&&<div style={{marginBottom:8}}>
      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>End date</label>
      <input type="date" value={endDate} onChange={e=>setEndDate(e.target.value)} min={effectiveStart||undefined} style={{width:"100%",padding:"7px 10px",borderRadius:8,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,color:T.ink,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>
    </div>}

    {/* Recurrence */}
    <div style={{marginBottom:8}}>
      <label style={{fontSize:11,color:T.muted,display:"block",marginBottom:3}}>Repeat</label>
      <select value={recurrence} onChange={e=>setRecurrence(e.target.value)} style={{width:"100%",padding:"7px 10px",borderRadius:8,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:12,cursor:"pointer",fontFamily:"'DM Sans',sans-serif",color:T.ink}}>
        {RECURRENCE_OPTIONS.map(o=><option key={o.id} value={o.id}>{o.label}</option>)}
      </select>
    </div>
  </>);
}

function GSBookingPanel({slot, selectedPartners, onBack, sendSchedulingRequest, weekDatesObj}) {
  const [title,setTitle] = useState("");
  const isoDate = weekDatesObj?.[slot.dayIdx]?.toISOString().slice(0,10) || null;
  const [startH,setStartH] = useState(slot.startH);
  const [endH,setEndH] = useState(Math.min(slot.endH,slot.startH+2));
  const [allDay,setAllDay] = useState(false);
  const [multiDay,setMultiDay] = useState(false);
  const [startDate,setStartDate] = useState(isoDate||"");
  const [endDate,setEndDate] = useState(isoDate||"");
  const [recurrence,setRecurrence] = useState("none");
  const [confirmed,setConfirmed] = useState(false);
  const [sending,setSending] = useState(false);
  const [sendError,setSendError] = useState(null);
  const ideas = ["Dinner out","Game night","Movie night","Cooking together","Bonfire / drinks","Brunch"];

  const handleConfirm = async () => {
    if(sending) return;
    setSending(true);
    setSendError(null);
    const effectiveDate=startDate||isoDate;
    const proposedDay = startDate?new Date(startDate+"T12:00:00").toLocaleDateString("en-US",{weekday:"long"}):GS_DAY_FULL[slot.dayIdx];
    const linked = selectedPartners.filter(p=>p.linkedUserId);
    const reqPayload = {
      proposedDay,
      proposedDate:effectiveDate,
      proposedStartH:allDay?0:startH,
      proposedEndH:allDay?24:endH,
      message:title||undefined,
      allDay,
      title:title||undefined,
      proposedEndDate:multiDay?endDate:undefined,
      recurrence:recurrence!=="none"?{freq:recurrence==="biweekly"?"weekly":recurrence,interval:recurrence==="biweekly"?2:1}:undefined,
    };
    try {
      await Promise.all(linked.map(p=>sendSchedulingRequest({
        toUserId:p.linkedUserId,
        relationshipType:p.type||"friend",
        toDisplayName:p.name,
        ...reqPayload,
      })));
      setConfirmed(true);
    } catch(e) {
      setSendError("Failed to send — please try again.");
    } finally {
      setSending(false);
    }
  };

  const summaryTime = allDay ? "All day" : gsFmtRange(startH,endH);
  const summaryDate = multiDay && endDate && endDate !== isoDate
    ? `${GS_DAY_FULL[slot.dayIdx]} → ${endDate}`
    : GS_DAY_FULL[slot.dayIdx];

  if(confirmed) return (<div style={{padding:28,textAlign:"center",animation:"popIn .3s ease"}}>
    <div style={{width:60,height:60,borderRadius:"50%",background:T.sage+"22",border:`2px solid ${T.sage}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:26,margin:"0 auto 16px"}}>✓</div>
    <h3 style={{fontSize:20,fontFamily:"'Crimson Pro',serif",fontWeight:300,marginBottom:8}}>Group hang proposal sent!</h3>
    <p style={{fontSize:13,color:T.muted,marginBottom:6}}>{summaryDate}, {summaryTime}</p>
    {recurrence!=="none"&&<p style={{fontSize:11,color:T.sage,marginBottom:6}}>Repeats {RECURRENCE_OPTIONS.find(o=>o.id===recurrence)?.label.toLowerCase()}</p>}
    <div style={{display:"flex",justifyContent:"center",gap:6,flexWrap:"wrap",marginBottom:6}}>
      {selectedPartners.map(p=><span key={p.id} style={{fontSize:11,padding:"2px 8px",borderRadius:20,background:p.color+"18",border:`1px solid ${p.color}40`,color:p.color}}>{p.name}</span>)}
    </div>
    <p style={{fontSize:12,color:T.muted,marginTop:10}}>{selectedPartners.filter(p=>p.linkedUserId).length>0?"Requests sent to everyone on Orbit.":"Hang saved — invite friends to Orbit to send requests."}</p>
  </div>);

  return (<div style={{padding:20,animation:"fadeUp .2s ease"}}>
    <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:18}}>
      <button onClick={onBack} style={{width:28,height:28,borderRadius:"50%",background:T.mist,border:"none",cursor:"pointer",color:T.muted,fontSize:14}}>←</button>
      <h3 style={{fontSize:16,fontFamily:"'Crimson Pro',serif",fontWeight:600}}>Book group hang</h3>
    </div>
    <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>With</p>
    <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:18}}>
      {selectedPartners.map(p=><span key={p.id} style={{display:"flex",alignItems:"center",gap:5,padding:"4px 10px",borderRadius:20,background:p.color+"18",border:`1px solid ${p.color}40`,fontSize:12,color:p.color,fontWeight:500}}><span style={{fontSize:11}}>●</span>{p.name}</span>)}
    </div>

    <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>Title</p>
    <input placeholder="Event title…" value={title} onChange={e=>setTitle(e.target.value)} style={{width:"100%",padding:"8px 11px",borderRadius:9,border:`1.5px solid ${T.edge}`,background:T.mist,fontSize:13,color:T.ink,marginBottom:10,fontFamily:"'DM Sans',sans-serif",outline:"none",boxSizing:"border-box"}}/>
    <div style={{display:"flex",flexWrap:"wrap",gap:5,marginBottom:14}}>
      {ideas.map(idea=><button key={idea} onClick={()=>setTitle(idea)} style={{padding:"4px 9px",borderRadius:16,background:title===idea?T.sage+"22":T.mist,border:`1px solid ${title===idea?T.sage+"55":T.edge}`,color:title===idea?"#4A7050":T.bark,fontSize:11,cursor:"pointer"}}>{idea}</button>)}
    </div>

    <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>When</p>
    <EventFormFields startH={startH} setStartH={setStartH} endH={endH} setEndH={setEndH} allDay={allDay} setAllDay={setAllDay} multiDay={multiDay} setMultiDay={setMultiDay} endDate={endDate} setEndDate={setEndDate} startDate={startDate} setStartDate={setStartDate} recurrence={recurrence} setRecurrence={setRecurrence} slotDayIdx={slot.dayIdx} slotEndH={slot.endH} isoDate={isoDate}/>

    <div style={{padding:"8px 12px",borderRadius:9,background:T.sage+"18",border:`1px solid ${T.sage}44`,marginBottom:14,fontSize:12,color:T.ink,fontWeight:600}}>
      🕐 {summaryDate}, {summaryTime}
      {recurrence!=="none"&&<span style={{fontSize:11,color:T.sage,fontWeight:500,marginLeft:6}}>· Repeats {RECURRENCE_OPTIONS.find(o=>o.id===recurrence)?.label.toLowerCase()}</span>}
    </div>

    {selectedPartners.some(p=>!p.linkedUserId)&&<div style={{padding:"8px 11px",borderRadius:9,background:T.amber+"18",border:`1px solid ${T.amber}44`,marginBottom:12,fontSize:11,color:T.bark}}>
      {selectedPartners.filter(p=>!p.linkedUserId).map(p=>p.name).join(", ")} {selectedPartners.filter(p=>!p.linkedUserId).length===1?"hasn't":"haven't"} joined Orbit — no request will be sent to them.
    </div>}
    {sendError&&<p style={{fontSize:11,color:T.red,marginBottom:8}}>{sendError}</p>}
    <button onClick={handleConfirm} disabled={sending} style={{width:"100%",padding:11,borderRadius:12,background:sending?T.mist:`linear-gradient(135deg,#5A8A5E,${T.sage})`,border:"none",color:sending?T.muted:"white",fontSize:14,fontWeight:600,cursor:sending?"default":"pointer",boxShadow:sending?"none":`0 4px 16px ${T.sage}55`,transition:"all .15s"}}>
      {sending?"Sending…":"Confirm & notify everyone"}
    </button>
  </div>);
}

function GSPersonRow({label, color, avail}) {
  return (<div style={{display:"flex",alignItems:"center",gap:8}}>
    <span style={{fontSize:11,color:T.muted,width:36,textAlign:"right",flexShrink:0}}>{label}</span>
    <div style={{flex:1,display:"flex",gap:2}}>
      {GS_DAYS.map((_,d)=>{
        const slots = avail[d] || [];
        const hours = slots.reduce((s,[a,b])=>s+(b-a),0);
        const pct = Math.min(hours/8,1);
        const rgb = color.startsWith("#") ? gsHexRgb(color) : "122,158,126";
        return (<div key={d} style={{flex:1,height:10,borderRadius:3,background:pct>0?`rgba(${rgb},${0.18+pct*0.5})`:T.edge}}/>);
      })}
    </div>
  </div>);
}

export function GroupScheduler({isMobile, weekDateNums, weekDatesObj, todayIdx, weekOffset, setWeekOffset, schedWeekRangeStr, onOpenPicker}) {
  const {people:PEOPLE,fetchPeerAvailability,sendSchedulingRequest,userId,calEvents} = usePeople();
  const [myAvail,setMyAvail] = useState(null);
  const [myEvents,setMyEvents] = useState([]);
  const activeDates = weekDateNums || GS_DATES;
  const activeTodayIdx = todayIdx !== undefined ? todayIdx : GS_TODAY;
  const fmtSlotDate = (di) => {
    if(weekDatesObj&&weekDatesObj[di]) { const d=weekDatesObj[di]; return `${_CAL_MONTHS[d.getMonth()]} ${d.getDate()}`; }
    return fmtWeekDate(di);
  };
  const [tf,setTf] = useState("all");
  const [selectedIds,setSelectedIds] = useState([1,3]);
  const [overlaps,setOverlaps] = useState({});
  const [selectedSlot,setSelectedSlot] = useState(null);
  const [panelMode,setPanelMode] = useState("windows");
  const [peerAvailMap,setPeerAvailMap] = useState({});

  useEffect(()=>{
    if(!fetchPeerAvailability||!selectedIds.length) return;
    const from = toLocalYMD(weekDatesObj?.[0]||WEEK_DATES[0]);
    const to   = toLocalYMD(weekDatesObj?.[6]||WEEK_DATES[6]);
    PEOPLE.filter(p=>selectedIds.includes(p.id)&&p.linkedUserId).forEach(p=>{
      fetchPeerAvailability(p.linkedUserId,from,to).then(data=>{
        if(data?.availability) setPeerAvailMap(m=>({...m,[p.id]:data.availability}));
      }).catch(()=>{});
    });
  },[selectedIds,fetchPeerAvailability,weekOffset]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    if(!userId||!fetchPeerAvailability) return;
    const from = toLocalYMD(weekDatesObj?.[0]||WEEK_DATES[0]);
    fetchPeerAvailability(userId,from).then(data=>{setMyAvail(data?.availability||null);setMyEvents(data?.events||[]);}).catch(()=>{});
  },[weekOffset,userId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    const newOverlaps = gsGroupOverlaps(selectedIds,myAvail,PEOPLE,peerAvailMap);
    setOverlaps(newOverlaps);
    setSelectedSlot(null);
    setPanelMode(gsTotalH(newOverlaps)===0?"calendar":"windows");
  },[selectedIds,myAvail,PEOPLE,peerAvailMap]); // eslint-disable-line react-hooks/exhaustive-deps

  const allPartners = PEOPLE.map(p=>({id:p.id,name:p.name,initials:p.ini,photo:p.photo||null,color:REL[p.type]?.color||T.partner,tags:p.tags,available:p.avail??null,type:p.type,linkedUserId:p.linkedUserId||null}));
  const visiblePartners = tf==="all" ? allPartners : allPartners.filter(p=>p.type===tf);
  const togglePartner = (id) => setSelectedIds(prev=>prev.includes(id)?prev.filter(i=>i!==id):[...prev,id]);
  const handleSlotClick = (slot) => { setSelectedSlot(slot); setPanelMode("book"); };
  const selectedPartners = allPartners.filter(p=>selectedIds.includes(p.id));
  const groupHours = gsTotalH(overlaps);
  const coverage = selectedIds.length+1;

  return (<div style={{display:"flex",flexDirection:"column",height:"100%",minHeight:500,background:T.bg,borderRadius:16,border:`1px solid ${T.edge}`,overflow:"hidden"}}>

    <div style={{background:T.surface,borderBottom:`1px solid ${T.edge}`,padding:"12px 20px",flexShrink:0}}>
      <div style={{display:"flex",gap:6,marginBottom:10,flexWrap:"wrap"}}>
        <button onClick={()=>setTf("all")} style={{padding:"4px 11px",borderRadius:16,border:"none",cursor:"pointer",background:tf==="all"?T.bark:T.mist,color:tf==="all"?"white":T.muted,fontSize:11,fontWeight:tf==="all"?600:400,flexShrink:0}}>All</button>
        {Object.entries(REL).map(([k,cfg])=>(
          <button key={k} onClick={()=>setTf(tf===k?"all":k)} style={{padding:"4px 10px",borderRadius:16,border:`1.5px solid ${tf===k?cfg.color+"50":"transparent"}`,cursor:"pointer",background:tf===k?cfg.color+"18":T.mist,color:tf===k?cfg.color:T.muted,fontSize:11,fontWeight:tf===k?600:400,flexShrink:0,display:"flex",alignItems:"center",gap:3}}>
            {cfg.icon} {cfg.plural}
          </button>
        ))}
      </div>
      <div style={{display:"flex",alignItems:isMobile?"flex-start":"center",gap:isMobile?10:14,flexWrap:"wrap",flexDirection:isMobile?"column":"row"}}>
        <div style={{flexShrink:0}}>
          <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:2}}>Select people</p>
          <p style={{fontSize:11,color:T.muted}}>Find when everyone's free</p>
        </div>
        <div style={isMobile?{display:"grid",gridTemplateColumns:"1fr 1fr",gap:7,width:"100%"}:{display:"flex",gap:7,flexWrap:"wrap",flex:1}}>
          {visiblePartners.map(p=><GSChip key={p.id} partner={p} selected={selectedIds.includes(p.id)} onToggle={togglePartner}/>)}
        </div>
        {selectedIds.length>=2&&<div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:12,padding:"8px 14px",borderRadius:12,background:groupHours>0?T.sage+"12":"#FDF0E6",border:`1px solid ${groupHours>0?T.sage+"44":T.partner+"30"}`,animation:"fadeIn .2s ease",flexShrink:0}}>
          <div>
            <p style={{fontSize:18,fontWeight:700,color:groupHours>0?"#4A7050":T.partner,fontFamily:"'Crimson Pro',serif",lineHeight:1}}>{groupHours}h</p>
            <p style={{fontSize:11,color:T.muted,marginTop:1}}>overlap</p>
          </div>
          <div style={{height:28,width:1,background:T.edge}}/>
          <div>
            <p style={{fontSize:14,fontWeight:700,color:T.ink,fontFamily:"'Crimson Pro',serif",lineHeight:1}}>{coverage}</p>
            <p style={{fontSize:11,color:T.muted,marginTop:1}}>people</p>
          </div>
        </div>}
      </div>
    </div>

    <div style={{display:"flex",alignItems:"center",gap:8,margin:"0 0 12px",flexWrap:"wrap",flexShrink:0}}>
      <div style={{display:"flex",background:T.mist,borderRadius:10,padding:3,gap:2,border:`1px solid ${T.edge}`,flexShrink:0}}>
        {[{id:"calendar",label:"📅 Calendar"},{id:"windows",label:"🕐 Available times"}].map(v=>(
          <button key={v.id} onClick={()=>setPanelMode(v.id)} style={{padding:"6px 14px",borderRadius:8,border:"none",cursor:"pointer",background:panelMode===v.id?T.surface:"transparent",color:panelMode===v.id?T.ink:T.muted,fontSize:11,fontWeight:panelMode===v.id?600:400,transition:"all .14s",boxShadow:panelMode===v.id?"0 1px 4px rgba(0,0,0,.08)":"none",whiteSpace:"nowrap"}}>{v.label}</button>
        ))}
      </div>
      {setWeekOffset&&<div style={{display:"flex",alignItems:"center",gap:4,marginLeft:"auto",background:T.surface,border:`1px solid ${T.edge}`,borderRadius:10,padding:"4px 8px"}}>
        <button onClick={()=>setWeekOffset(w=>w-1)} style={{width:22,height:22,borderRadius:"50%",background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:12,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>‹</button>
        {weekOffset!==0&&<button onClick={()=>setWeekOffset(0)} style={{padding:"1px 7px",borderRadius:8,background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",color:T.bark,fontSize:11,fontWeight:600,flexShrink:0}}>Today</button>}
        <span style={{fontSize:11,fontWeight:600,color:T.ink,whiteSpace:"nowrap",padding:"0 4px"}}>{schedWeekRangeStr}</span>
        <button onClick={()=>setWeekOffset(w=>w+1)} style={{width:22,height:22,borderRadius:"50%",background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",color:T.muted,fontSize:12,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>›</button>
        {onOpenPicker&&<button onClick={onOpenPicker} style={{width:22,height:22,borderRadius:6,background:T.mist,border:`1px solid ${T.edge}`,cursor:"pointer",fontSize:12,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>📅</button>}
      </div>}
    </div>

    {panelMode==="calendar"&&<div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",borderRadius:12,border:`1px solid ${T.edge}`,background:T.surface}}>
      <div style={{flex:1,overflowY:"auto",display:"flex",position:"relative"}}>
        <div style={{width:42,flexShrink:0,paddingTop:44,position:"sticky",left:0,background:T.surface,zIndex:10,borderRight:`1px solid ${T.edge}`}}>
          {Array.from({length:GS_VISIBLE_HOURS},(_,i)=>(
            <div key={i} style={{height:GS_HOUR_HEIGHT,display:"flex",alignItems:"flex-start",paddingTop:2,paddingRight:6,justifyContent:"flex-end"}}>
              <span style={{fontSize:11,color:T.muted,lineHeight:1}}>{gsFmtH(GS_GRID_START+i)}</span>
            </div>
          ))}
        </div>
        <div style={{flex:1,display:"flex",minWidth:0}}>
          {GS_DAYS.map((_,d)=>{
            const dayOrbitSlots=calEvents.filter(ev=>ev.source==="orbit"&&ev.id?.startsWith("orbit-sched-")&&!ev.allDay&&ev.day===d&&weekDatesObj?.[d]&&ev.date===toLocalYMD(weekDatesObj[d]));
            const overlapsOrbit=(ev)=>dayOrbitSlots.some(o=>Math.abs(o.startH-ev.startH)<0.1&&Math.abs(o.endH-ev.endH)<0.1);
            const dayMyEvts=myEvents.filter(ev=>!ev.allDay&&ev.day===d&&ev.status!=='free'&&!overlapsOrbit(ev));
            const dayCalEvts=calEvents.filter(ev=>{
              if(ev.allDay||ev.day!==d||!weekDatesObj?.[d]||ev.date!==toLocalYMD(weekDatesObj[d])) return false;
              if(ev.source==="orbit"&&ev.id?.startsWith("orbit-sched-")) return true;
              if(overlapsOrbit(ev)) return false;
              return !dayMyEvts.some(m=>Math.abs(m.startH-ev.startH)<0.1&&Math.abs(m.endH-ev.endH)<0.1);
            });
            return (<GSHeatmapCol key={d} dayIdx={d} selectedIds={selectedIds} overlaps={overlaps} selectedSlot={selectedSlot} onSlotClick={s=>{handleSlotClick(s);setPanelMode("windows");}} onCellClick={s=>handleSlotClick(s)} myAvail={myAvail} weekDateNums={activeDates} todayIdx={activeTodayIdx} people={PEOPLE} peerAvailMap={peerAvailMap} myEvents={[...dayMyEvts,...dayCalEvts]}/>);
          })}
        </div>
      </div>
      <div style={{borderTop:`1px solid ${T.edge}`,background:T.surface,padding:"12px 16px 12px 58px",flexShrink:0}}>
        <p style={{fontSize:11,color:T.muted,textTransform:"uppercase",letterSpacing:"0.08em",marginBottom:8}}>Individual availability</p>
        <div style={{display:"flex",flexDirection:"column",gap:6}}>
          <GSPersonRow label="You" color={T.partner} avail={myAvail||{}}/>
          {selectedPartners.map(p=><GSPersonRow key={p.id} label={p.name} color={p.color} avail={peerAvailMap[p.id]||{}}/>)}
        </div>
      </div>
    </div>}

    {panelMode==="windows"&&<div style={{flex:1,overflowY:"auto"}}>
      {groupHours===0
        ?<div style={{padding:20,borderRadius:12,background:T.mist,border:`1px solid ${T.edge}`,textAlign:"center"}}>
          <p style={{fontSize:22,marginBottom:8}}>😔</p>
          <p style={{fontSize:14,fontWeight:600,color:T.bark,marginBottom:4}}>No full overlap</p>
          <p style={{fontSize:12,color:T.muted,marginBottom:14}}>No time when everyone is free this week.</p>
          <p style={{fontSize:11,color:T.muted,marginBottom:8}}>Try removing someone:</p>
          <div style={{display:"flex",flexWrap:"wrap",gap:5,justifyContent:"center"}}>
            {selectedPartners.map(p=><button key={p.id} onClick={()=>togglePartner(p.id)} style={{padding:"4px 10px",borderRadius:20,background:p.color+"18",border:`1px solid ${p.color}44`,color:p.color,fontSize:11,cursor:"pointer"}}>Remove {p.name}</button>)}
          </div>
          <div style={{marginTop:14,padding:"10px 12px",borderRadius:9,background:"#FDF0E6",border:`1px solid ${T.partner}30`}}>
            <p style={{fontSize:11,color:"#8A5030",fontWeight:600,marginBottom:3}}>💡 Partial overlap</p>
            <p style={{fontSize:11,color:T.muted,lineHeight:1.5}}>Some pairs have shared windows. Try scheduling 1:1 first.</p>
          </div>
          <button onClick={()=>setPanelMode("calendar")} style={{marginTop:12,padding:"8px 16px",borderRadius:10,background:T.clay,border:"none",color:"white",fontSize:12,fontWeight:600,cursor:"pointer"}}>Pick any time →</button>
        </div>
        :Object.entries(overlaps).map(([di,slots])=>{
          if(!slots.length) return null;
          return (<div key={di} style={{marginBottom:16}}>
            <p style={{fontSize:11,fontWeight:700,color:T.bark,textTransform:"uppercase",letterSpacing:"0.07em",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
              {GS_DAYS[+di]} · {fmtSlotDate(+di)}
              {+di===activeTodayIdx&&<span style={{fontSize:11,background:T.partner,color:"white",padding:"1px 6px",borderRadius:8}}>today</span>}
            </p>
            {slots.map(([s,e],i)=>{
              const key = `${di}-${s}-${e}`;
              const isSel = selectedSlot?.key===key;
              return (<div key={i} onClick={()=>handleSlotClick({key,dayIdx:+di,startH:s,endH:e})} style={{padding:"10px 12px",borderRadius:10,marginBottom:6,background:isSel?T.sage+"18":T.mist,border:`1.5px solid ${isSel?T.sage:T.edge}`,cursor:"pointer",transition:"all .12s"}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                  <div>
                    <p style={{fontSize:13,fontWeight:700,color:T.ink}}>{gsFmtRange(s,e)}</p>
                    <p style={{fontSize:11,color:T.sage,marginTop:2}}>🕐 {e-s}h · all {coverage} free</p>
                  </div>
                  <span style={{fontSize:11,padding:"3px 8px",borderRadius:10,background:T.sage,color:"white",fontWeight:600,marginTop:1,flexShrink:0}}>Book</span>
                </div>
                <div style={{display:"flex",gap:4,marginTop:8}}>
                  {[{id:0,name:"You",color:T.partner,initials:"Me"},...selectedPartners].map((pp,pi)=>(
                    <div key={pi} style={{width:20,height:20,borderRadius:"50%",background:pp.color+"22",border:`1.5px solid ${pp.color}66`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:7,fontWeight:700,color:pp.color}}>{pp.initials||"Me"}</div>
                  ))}
                </div>
              </div>);
            })}
          </div>);
        })
      }
    </div>}

    {selectedSlot&&<GSBookingPanel slot={selectedSlot} selectedPartners={selectedPartners} onBack={()=>{setPanelMode("windows");setSelectedSlot(null);}} sendSchedulingRequest={sendSchedulingRequest} weekDatesObj={weekDatesObj}/>}
  </div>);
}
